// extracted by mini-css-extract-plugin
module.exports = {"dontMiss":"PublicNews_dontMiss__2M7PB","news":"PublicNews_news__2u4LL","root":"PublicNews_root__3yx1J"};